<!-- /SectionTwo/ -->
<template>
  <div class="ThirdSectionContainer">
    <!-- 2 div left and right -->
    <div class="leftBox">
      <div class="imageContainer">
         <img class="leftBoxImage" :src="image" alt="image">
         <a type="button" class="signInBtn " href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" target="_blank"  style="text-decoration: none;color: white;"> 
         
        <Icon class="iconbtn" icon="fluent:arrow-right-24-regular" height="20" />
        Demander une démonstration
      
    </a>
      <a href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" target="_blank" class="text" style="text-decoration: none;color: white;" >
      <Icon class="icon" icon="bi:play-btn" height="80" />
      </a>
      </div>
    </div>
    <div class="rightBox">
      <div class="firstsection">
        <h1 class="title">
          Vers un avenir collaboratif et digitalisé avec Prexange
        </h1>
        <p class="detail">
          Un marché en mouvement qui appelle à de nouvelles synergies pour répondre aux besoins en constante évolution
          des acteurs du crédit immobilier.
        </p>
        <img class="rightBoxImage" :src="image2" alt="">
      </div>
      <div class="secondsection">
        <div class="card">
          <div>
           <img :src="icon18" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              SOLUTION
            </span>
            <P class="detailcard">
              Déploiement d’une solution digitale “pilotée” dans laquelle l’humain et sa satisfaction restent au coeur des préoccupations de chacun.
            </P>
          </div>
        </div>
        <div class="card">
          <div>
           <img :src="icon19" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              CONFORMITE
            </span>
            <P class="detailcard">
              Volonté de mettre en conformité tout un pan du secteur de l’immobilier et des investissements faisant appel à un financement bancaire.            </P>
          </div>
        </div>
        <div class="card">
          <div>
           <img :src="icon20" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              GAIN DE PRODUCTIVITE
            </span>
            <P class="detailcard">
              Accent mis sur l’efficience au travail; chacun devant pouvoir exercer son coeur de métier sans perte de temps.            </P>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Icon } from '@iconify/vue2';
import image from '@/assets/images/bg3sec.png';
import image2 from '@/assets/images/se3box2.png';
import icon18 from '@/assets/images/icon18.png';
import icon19 from '@/assets/images/icon19.png';
import icon20 from '@/assets/images/icon20.png';


export default {
  name: 'ThirdSection',
  components: {
    Icon,
  },
  data() {
    return {
      image: image,
      image2: image2,
      icon18: icon18,
      icon19: icon19,
      icon20: icon20,
      isSidebarOpen: false,
    };
  },
};
</script>


<style lang="scss">
@import './ThirdSection.scss'
</style>